
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"2 min read","minutes":1.91,"time":114600,"words":382}
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`En rendant visible les débats des experts et des chercheurs autour des enjeux éthiques (Jobin et al, 2019,  Mittelstadt, 2019) mais aussi en médiatisant les controverses qui émergent parfois au sein des communautés d’utilisateurs sur les effets négatifs des technologies de calcul, les médias contribuent à forger les représentations et à définir les formes d’acceptabilité de l’IA dans nos sociétés. Des travaux ont montré une visibilité croissante du sujet de l’IA dans la couverture médiatique ces dernières années (Brennen et al, 2018), se concentrant principalement sur les avancées technologiques et sur les développements potentiels dans les secteurs du commerce et de l’industrie. Pourtant, les questions éthiques et les problèmes sociaux, tels que les risques de discrimination, les biais, la vie privée sont des thématiques également présentes au sein de la sphère médiatique bien que sous-représentées.`}</p>
    <p>{`Notre recherche vise à explorer les discours critiques sur l’IA dans la sphère médiatique : `}</p>
    <ul>
      <li parentName="ul">{`Quelles sont les controverses produites par ces technologies qui sont médiatisées dans la presse ? `}</li>
      <li parentName="ul">{`Quels types d’agents techniques et humains sont impliqués dans ces controverses ? `}</li>
      <li parentName="ul">{`Quels troubles sont-ils accusés de produire dans la société ?`}</li>
    </ul>
    <p>{`A partir de méthode de traitement automatique du langage sur un corpus de presse, nous montrons que le thème de l’IA occupe un espace de plus en plus important dans la presse depuis 5 ans. L’espace médiatique se structure de manière thématique autour de différentes technologies de calcul et domaines d’applications et peut être divisé en deux sous-ensembles sémantiques. L’analyse comparée de ces deux espaces sémantiques rend compte de `}<strong parentName="p">{`deux régimes de critique dominants`}</strong>{`, mobilisant une variété d’entités techniques et humaines, ainsi que des temporalités et des enjeux différents.
Le premier est fondé sur `}<strong parentName="p">{`les injustices produites par les algorithmes`}</strong>{` qui façonnent nos environnements de calcul quotidiens et sont associés à un discours critique portant sur les biais, les discriminations, la surveillance et la censure dont des populations spécifiques sont victimes.
Le second porte sur `}<strong parentName="p">{`les peurs de l’autonomie de l’IA et des robots`}</strong>{` qui, en tant qu’entités techniques autonomes et incarnées, sont associées à un discours prophétique, alertant sur notre capacité à contrôler ces agents simulant ou dépassant nos capacités physiques et cognitives, mettant ainsi en péril notre sécurité physique, notre modèle économique et menaçant ainsi l’humanité tout entière.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  {
    id: "introduction",
    level: 2,
    title: "Introduction",
    children: [
        
      ]
  }
]

export const frontMatter = {}

